import { Button } from "@shopify/polaris";
import {
  DEFAULT_SUBSCRIPTION_PLANS,
  SUBSCRIPTION_PLAN_ENTERPRISE,
  SUBSCRIPTION_PLAN_FREE
} from "../../../../../../../../constants/subscriptionPlans.js";
import { useCallback, useMemo } from "react";
import { differenceInDays } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useAppMutation } from "../../../../../../../hooks/index.js";
import { RootState } from "../../../../../../../store/index.js";
import { STOCKHIDE_CONTACT_US_LINK } from "../../../../../../../../constants/links.js";
import { OPEN_MODAL_SWITCHING_PLAN } from "../../../../../../../constants/modalTypes.js";
import { openModal } from "../../../../../../../store/features/modal.js";
import { useAppDispatch, useAppSelector } from "../../../../../../../hooks/redux.js";

const SubmitButton = ({ plan, subscriptionInterval, shopifyAppSubscriptionInterval }) => {
  const dispatch = useAppDispatch();
  const shop = useAppSelector((state) => state.shop.data);
  const host = useAppSelector((state) => state.host.data);


  const { mutate, isLoading } = useAppMutation({
    url: "/api/app-subscription/create",
    reactMutationOptions: {
      onSuccess: ({ confirmUrl }) => {
        if (confirmUrl) {
          window.open(confirmUrl, "_top");
        }
      }
    }
  });

  const handleChoose = useCallback(() => {
    if (plan.name === SUBSCRIPTION_PLAN_ENTERPRISE) {
      return window.open(STOCKHIDE_CONTACT_US_LINK, "_blank");
    }

    if (shop?.shopifyAppSubscription?.trialDays) {
      const trialDays = differenceInDays(
          new Date(),
          new Date(shop?.trialUseDate)
      );

      if (shop?.trialUseDate) {
        if (trialDays < 6) {
          return dispatch(openModal({
            modalType: OPEN_MODAL_SWITCHING_PLAN,
            modalData: { planId: plan.id, subscriptionInterval, host}
          }));
        }
      } else {
        return dispatch(openModal({
          modalType: OPEN_MODAL_SWITCHING_PLAN,
          modalData: { planId: plan.id, subscriptionInterval, host }
        }));
      }
    }

    mutate({ planId: plan.id, subscriptionInterval, host });
  }, [mutate, plan, subscriptionInterval]);

  const buttonText = useMemo(() => {

    if (shop?.subscriptionPlan?.name === plan.name && (subscriptionInterval === shopifyAppSubscriptionInterval || plan.isCustom)) {
      return "Selected";
    }

    if (shop.subscriptionPlan && !DEFAULT_SUBSCRIPTION_PLANS.includes(shop.subscriptionPlan?.name) && plan.name === SUBSCRIPTION_PLAN_ENTERPRISE) {
      return "Current";
    }

    if (plan.name === SUBSCRIPTION_PLAN_ENTERPRISE) {
      return "Get in touch";
    }

    if (plan.name === SUBSCRIPTION_PLAN_FREE && shop?.subscriptionPlan?.name === SUBSCRIPTION_PLAN_FREE) {
      return "Selected";
    }

    if (plan.name === SUBSCRIPTION_PLAN_FREE) {
      return "Continue free";
    }

    if (shop.trialUseDate) {
      return "Choose";
    }

    return "Start a 5-day trial";
  }, [plan, subscriptionInterval, shopifyAppSubscriptionInterval]);

  const isDisabled = useMemo(() => {

    if (plan.name === SUBSCRIPTION_PLAN_FREE && shop?.subscriptionPlan?.name === SUBSCRIPTION_PLAN_FREE) {
      return true;
    }

    return shop?.subscriptionPlan?.name === plan.name && (subscriptionInterval === shopifyAppSubscriptionInterval || plan.isCustom);
  }, [plan, subscriptionInterval, shopifyAppSubscriptionInterval]);

  return (
    <Button
      primary
      onClick={handleChoose}
      loading={isLoading}
      disabled={isDisabled}
    >
      {buttonText}
    </Button>
  );
};

export default SubmitButton;
